module.exports = __webpack_public_path__ + "static/img/img5.f1f4c33.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/activity/double11/2/img5.png
// module id = SpiD
// module chunks = 0